import clsx from 'clsx'

interface Props {
    statusId: number
    statusText: string
}

const statusColor: Record<number, string> = {
    69033: 'bg-green-700',
    69040: 'bg-primary',
    69030: 'bg-amber-600',
    69035: 'bg-primary',
    69032: 'bg-gray-600',
    69031: 'bg-green-700',
    68968: 'bg-red-600',
}

export function getOrderStateColor(statusId: Props['statusId']) {
    return statusColor[statusId]
}

export default function OrderState({ statusId, statusText }: Props) {
    return (
        <span
            className={clsx(
                'badge text-white whitespace-nowrap',
                statusColor[statusId]
            )}
        >
            {statusText}
        </span>
    )
}
